import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import rootReducer from './reducers';
import redispatchMiddleware from './middlewares/redispatch-middleware';
import jsonapiMiddleware from './middlewares/jsonapi-middleware';
import workflowsMiddleware from './middlewares/workflows-middleware';
import pushpinsMiddleware from './middlewares/pushpins-middleware';
import analyticsMiddleware from './middlewares/analytics-middleware';
import thumbnailsMiddleware from './middlewares/thumbnails-middleware';
import permissionsMiddleware from './middlewares/permissions-middlware';
import featureFlags, { FEATURE_FLAGS } from '../utils/featureFlags';
import getRfiApiMiddleware from './middlewares/api/get-rfi-api-middleware';

const initialState = {
  issues: {
    collection: {},
  },
};

export default ({
  redispatcher,
  jsonApi,
  pushpinsControl,
  appHistory,
  docsSDK,
  analyticsManager,
  devToolsCaption,
} = {}) => {
  // middleware executed in left-to-right order:
  const middleware = [
    thunkMiddleware,
    getRfiApiMiddleware(jsonApi),
    jsonapiMiddleware(jsonApi, docsSDK, redispatcher),
    workflowsMiddleware(jsonApi),
    analyticsMiddleware(analyticsManager),
    thumbnailsMiddleware(),
    promiseMiddleware(),
    redispatchMiddleware(redispatcher),
    routerMiddleware(appHistory),
    permissionsMiddleware(),
  ];
  if (pushpinsControl) {
    middleware.push(pushpinsMiddleware(pushpinsControl));
  }

  const enhancer = applyMiddleware(...middleware);
  const composeEnhancers = composeWithDevTools({
    name: devToolsCaption || 'RFI package',
  });

  const showReduxDevtools = featureFlags.get(FEATURE_FLAGS.RFIS_REDUX_DEVTOOLS);

  // Note: only Redux >= 3.1.0 supports passing enhancer as third argument.
  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  const rootStore = createStore(
    rootReducer(appHistory),
    initialState,
    showReduxDevtools ? composeEnhancers(enhancer) : enhancer
  );

  return rootStore;
};
